import React, { useEffect, useState, useContext } from 'react';
import { Container, Row, Spinner } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { UserContext } from '../../App';
import Payment from '../Payment/Payment';
import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';


const CheckoutForm = (props) => {
    const { _id } = useParams();
    const [loggedInUser,setLoggedInUser] = useContext(UserContext);

    const [services, setServices] = useState([]);

    useEffect(() => {
        fetch('https://radiant-stream-26422.herokuapp.com/services')
        .then(res => res.json())
        .then(data => setServices(data))
    }, [])

    const match = services.find(pd => pd._id === _id);
    const stripe = useStripe();
    const elements = useElements();
  
    const handleSubmit = async (event) => {
      event.preventDefault();

      if (!stripe || !elements) {
        return;
      }
  
      const cardElement = elements.getElement(CardElement);
  
      const {error, paymentMethod} = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
      });

    const servicesData = {
        name: match?.name,
        price: match?.price,
        imageURL: match?.imageURL,
        userName: loggedInUser.displayName,
        userEmail: loggedInUser.email,
        orderTime: new Date().toDateString('dd/M/yyyy'),
        cardName: paymentMethod.card.brand,
        paymentId: paymentMethod.id,
    };
    const url =`https://radiant-stream-26422.herokuapp.com/addNewOrder`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(servicesData)
    });

    if (error) {
    console.log('[error]', error);
    } else {
    console.log('[PaymentMethod]', paymentMethod.id);
    }
    };

    return (
        <div>
            <Container>
                <Row>
                    <div className="col-md-12 slide mt-5">
                        <div className="checkout-details mt-5">
                            <h2>CheckOut</h2>
                            <table className="table table-stripped mt-5">
                                <thead>
                                    <tr>
                                    <th scope="col">Product Image</th>
                                    <th scope="col">Product Name</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Flower Price</th>
                                    </tr>
                                </thead>
                                <tr>
                                    <td><img src={match?.imageURL} alt={match?.name} /></td>
                                    <td>{match?.name}</td>
                                    <td>1</td>
                                    <td>$ {match?.price}</td>
                                </tr>
                            </table>
                        </div>
                        <div className="offset-md-8 col-md-4 payment-area">
                            <form onSubmit={handleSubmit}>
                                <CardElement></CardElement>
                                <Link to={`/`} type="submit" disabled={!stripe}>
                                    Pay Now
                                </Link>
                            </form>
                        </div>
                    </div>
                </Row>
            </Container>
        </div>
    );
};
export default CheckoutForm;